/* eslint-disable */

import { Helmet } from 'react-helmet-async';
import InfoTooltip from '../components/InfoTooltip';
import { useNavigate } from 'react-router-dom';
import { filter } from 'lodash';
import { useEffect, useState } from 'react';
import { FaRegCopy } from 'react-icons/fa';
// @mui
import {
  Card,
  Table,
  Stack,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  IconButton,
  TableContainer,
  TablePagination,
  CircularProgress,
  TextField,
  Box,
  Chip,
  Button,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
// components

import Scrollbar from '../components/scrollbar';
import { formatToHHMM, formatToYYYYMMDD } from 'src/utils/dateFormatter';
import { BsFillFilterCircleFill } from 'react-icons/bs';
// mock
import { getBookings, getBookingsSettings, updateProcessBookingsCron } from '../helper/backend_helper';
import appConfig from '../config';
import { SolutionListHead } from '../components/addSolution';
import BookingFilterDrawer from 'src/components/bookingsFilter';
import useDebounce from 'src/hooks/useDebounce';
import { Download } from 'lucide-react';
import { toast } from 'react-toastify';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'guestName', label: 'Guest Name', alignRight: true },
  { id: 'BnBShortName', label: 'BnBShortName', alignRight: true },
  { id: 'actions', label: 'bookingCode', alignRight: false },
  { id: 'actions', label: 'bookingId', alignRight: false },
  { id: 'checkInDate', label: 'checkInDate', alignRight: false },
  { id: 'checkInStatus', label: 'checkInStatus', alignRight: false },
  { id: '2', label: 'checkInTime', alignRight: false },
  { id: 'checkOutDate', label: 'checkOutDate', alignRight: false },
  { id: '3', label: 'checkOutTime', alignRight: false },
  { id: '5', label: 'cityTax', alignRight: false },
  { id: '7', label: 'email', alignRight: false },
  { id: '6', label: 'Internal Note', alignRight: false },
  { id: '7', label: 'bed Configuration needed', alignRight: false },
  { id: 'actions', label: 'extraRequest', alignRight: false },
  { id: 'actions', label: 'kids', alignRight: false },
  { id: 'actions', label: 'language', alignRight: false },
  { id: 'actions', label: 'checkIn Url', alignRight: false },
  { id: 'actions', label: 'noOfGuests', alignRight: false },
  { id: 'actions', label: 'phone', alignRight: false },
  { id: 'gpsSharing', label: 'GPS Sharing', alignRight: false },
  { id: 'guestLeft', label: 'Geust Checked Out', alignRight: false },
  { id: 'gpsSharing', label: 'Money Left', alignRight: false },
  { id: '', label: '', alignRight: false },
  { id: '', label: 'Link', alignRight: false },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_user) =>
        _user.title.toLowerCase()?.indexOf(query.toLowerCase()) !== -1 ||
        _user.category?.name.toLowerCase()?.indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function AddSolutionPage() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [totalCount, setTotalCount] = useState(0);
  const [order, setOrder] = useState('asc');

  const [orderBy, setOrderBy] = useState('BnBShortName');

  const [users, setUsers] = useState([]);

  const [executionTime, setExecutionTime] = useState('');
  const [krossLogOpen, setKrossLogOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filters, setFilters] = useState({
    guestName: '',
    bnbShortName: '',
    bookingCode: '',
    bookingId: '',
    checkInDate: null,
    checkOutDate: null,
    checkInTime: null,
    checkOutTime: null,
    checkInStatus: '',
  });
  const [pendingFilters, setPendingFilters] = useState({ ...filters });

  const handleSearchText = (event) => {
    setSearchText(event.target.value);
  };

  const debouncedSearchTerm = useDebounce(searchText, 500);

  // async function fetchData() {
  //   const params = {
  //     page: page + 1,
  //     limit: rowsPerPage,
  //     // search: searchText,
  //     ...filters,
  //   };
  //   try {
  //     setLoading(true);
  //     const settingResponse = await getBookingsSettings();
  //     setExecutionTime(settingResponse?.data?.data?.executionTime);
  //     const usersResponse = await getBookings(params);
  //     console.log(usersResponse?.data);
  //     setUsers(usersResponse?.data?.data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //     setLoading(false);
  //   }
  // }

  async function fetchData(currentPage = page, currentRowsPerPage = rowsPerPage, currentFilters = filters) {
    const data = {
      page: currentPage + 1,
      limit: currentRowsPerPage,
      ...currentFilters,
      search: debouncedSearchTerm,
      checkInDate: formatToYYYYMMDD(currentFilters?.checkInDate),
      checkOutDate: formatToYYYYMMDD(currentFilters?.checkOutDate),
      checkInTime: formatToHHMM(currentFilters?.checkInTime),
      checkOutTime: formatToHHMM(currentFilters?.checkOutTime),
    };
    console.log();
    try {
      setLoading(true);
      const settingResponse = await getBookingsSettings();
      setExecutionTime(settingResponse?.data?.data);
      const usersResponse = await getBookings(data);
      console.log(usersResponse?.data);
      setUsers(usersResponse?.data?.data || []);
      setTotalCount(usersResponse?.data?.meta?.total || 0);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchData(page, rowsPerPage, filters);
  }, [page, rowsPerPage, filters, debouncedSearchTerm]);

  const [loading, setLoading] = useState(false);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  // Filter
  const handleInputChange = (field) => (event) => {
    setPendingFilters({ ...pendingFilters, [field]: event.target.value });
  };

  const handleDateChange = (field) => (value) => {
    setPendingFilters({ ...pendingFilters, [field]: value });
  };

  const handleApplyFilters = () => {
    setFilters({ ...pendingFilters });
    // setDrawerOpen(false);
  };

  const handleClearFilters = () => {
    setPendingFilters({
      guestName: '',
      bnbShortName: '',
      bookingCode: '',
      bookingId: '',
      checkInDate: null,
      checkOutDate: null,
      checkInTime: null,
      checkOutTime: null,
      checkInStatus: '',
    });

    // setDrawerOpen(false);
  };
  console.log(totalCount);
  let filteredUsers = [];
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - totalCount) : 0;

  filteredUsers = applySortFilter(users, getComparator(order, orderBy), '');

  const isNotFound = !filteredUsers.length;

  const hanldeUpdateProcessBookingsCron = async (isFuture) => {
    try {
      setLoading(true);
      await updateProcessBookingsCron(isFuture);
      setLoading(false);
    } catch (error) {
      const status = error.response?.status;
      console.log(error);
      const message =
        (status >= 400 && status < 500 && error.response?.data?.errors[0]?.detail) ||
        error.response?.data?.message ||
        (error.request ? 'No response from server. Please check your connection.' : error.message) ||
        'Failed to verify number. Please try again.';

      toast.error(message);
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title> process Bookings </title>
      </Helmet>

      <Card sx={{ p: 2 }}>
        <Stack
          direction={{ xs: 'column', sm: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
          spacing={2}
        >
          <Stack direction={{ xs: 'column', sm: 'column', md: 'row' }} alignItems="center" spacing={2} width="100%">
            <Typography variant="h5" sx={{ minWidth: 150 }}>
              Process Bookings{' '}
              <InfoTooltip
                width={20}
                title="Reservations synced automatically from your channel manager (Krossbooking), refreshed every minute. Each row is a booking with its check-in/out dates, status, guest and city tax. Use Fetch to pull the latest now, Fetch Future Bookings for upcoming stays, and Last Kross Log to see the most recent sync."
              />
            </Typography>

            <TextField
              onChange={handleSearchText}
              value={searchText}
              size="small"
              id="outlined-search"
              label="Search"
              type="search"
              fullWidth={false}
            />

            <Box
              onClick={() => setDrawerOpen(true)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                gap: 1,
                padding: '8px',
                '&:hover': {
                  color: 'primary.main',
                  backgroundColor: '#F0F0F0',
                  borderRadius: '4px',
                },
              }}
            >
              <BsFillFilterCircleFill />
              <Typography variant="body2">Filter</Typography>
            </Box>
            <Tooltip title="Next 60 days" arrow>
              <Button
                onClick={() => hanldeUpdateProcessBookingsCron(false)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  gap: 1,
                  padding: '8px',
                  '&:hover': {
                    color: 'primary.main',
                    backgroundColor: '#F0F0F0',
                    borderRadius: '4px',
                  },
                }}
                disabled={loading || executionTime?.isRunning}
              >
                <Download />
                <Typography variant="body2">Fetch</Typography>
              </Button>
            </Tooltip>
            <Tooltip title="Next 365 days" arrow>
              <Button
                onClick={() => hanldeUpdateProcessBookingsCron(true)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  gap: 1,
                  padding: '8px',
                  '&:hover': {
                    color: 'primary.main',
                    backgroundColor: '#F0F0F0',
                    borderRadius: '4px',
                  },
                }}
                disabled={loading || executionTime?.isRunning}
              >
                <Download />
                <Typography variant="body2">Fetch Future Bookings</Typography>
              </Button>
            </Tooltip>
            <Tooltip title="Show only the latest Kross API call log" arrow>
              <Button
                onClick={() => setKrossLogOpen(true)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  cursor: 'pointer',
                  gap: 1,
                  padding: '8px',
                  '&:hover': {
                    color: 'primary.main',
                    backgroundColor: '#F0F0F0',
                    borderRadius: '4px',
                  },
                }}
              >
                <Typography variant="body2">Last Kross Log</Typography>
              </Button>
            </Tooltip>
          </Stack>

          <Box sx={{ pt: { xs: 1, md: 0 } }}>
            <Typography variant="body2">Current Status:</Typography>
            <Typography variant="body2">
              <Chip
                label={executionTime?.isRunning ? 'Running' : 'Not Running'}
                size="small"
                variant="outlined"
                color={executionTime?.isRunning ? 'primary' : 'error'}
              />
            </Typography>
          </Box>

          <Box sx={{ pt: { xs: 1, md: 0 } }}>
            <Typography variant="body2">Last Execution Time:</Typography>
            <Typography variant="body2">{executionTime?.executionTime}</Typography>
          </Box>
          <Box sx={{ pt: { xs: 1, md: 0 } }}>
            <Typography variant="body2">Last Updated:</Typography>
            <Typography variant="caption">{new Date(executionTime?.updatedAt).toLocaleString()}</Typography>
          </Box>
        </Stack>
        <Dialog open={krossLogOpen} onClose={() => setKrossLogOpen(false)} maxWidth="md" fullWidth>
          <DialogTitle>Last Kross API Call</DialogTitle>
          <DialogContent dividers>
            {executionTime?.lastKrossCall ? (
              <Box
                component="pre"
                sx={{
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  bgcolor: '#0f172a',
                  color: '#e2e8f0',
                  borderRadius: 1,
                  p: 2,
                  fontSize: 12,
                }}
              >
                {JSON.stringify(executionTime.lastKrossCall, null, 2)}
              </Box>
            ) : (
              <Typography variant="body2">No Kross call has been logged yet.</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setKrossLogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table>
              <SolutionListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={users.length}
                numSelected={0}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row) => {
                    const {
                      guestName,
                      _id,
                      BnBShortName,
                      bedConfirmation,
                      bookingCode,
                      bookingId,
                      checkInDate,
                      checkInStatus,
                      checkInTime,
                      checkOutDate,
                      checkOutTime,
                      cityTax,
                      email,
                      extraRequest,
                      kids,
                      language,
                      noOfGuests,
                      phone,
                      checkInURL,
                      internal_note: internalNote,
                      gpsSharing,
                      isCheckOut,
                      isPaymentLeft,
                    } = row;

                    return (
                      <TableRow hover key={_id}>
                        <TableCell align="center">{guestName}</TableCell>
                        <TableCell align="center">{BnBShortName}</TableCell>

                        <TableCell align="center">{bookingCode}</TableCell>
                        <TableCell align="center">{bookingId}</TableCell>
                        <TableCell align="center">{checkInDate}</TableCell>
                        <TableCell align="center">{checkInStatus}</TableCell>
                        <TableCell align="center">{checkInTime}</TableCell>
                        <TableCell align="center">{checkOutDate}</TableCell>
                        <TableCell align="center">{checkOutTime}</TableCell>
                        <TableCell align="center">{cityTax}</TableCell>
                        <TableCell align="center">{email}</TableCell>

                        <TableCell align="center">{internalNote}</TableCell>

                        <TableCell align="center">{bedConfirmation}</TableCell>
                        <TableCell align="center">{extraRequest}</TableCell>
                        <TableCell align="center">{kids}</TableCell>
                        <TableCell align="center">{language}</TableCell>
                        <TableCell align="center">{checkInURL}</TableCell>
                        <TableCell align="center">{noOfGuests}</TableCell>
                        <TableCell align="center">{phone}</TableCell>
                        <TableCell align="center">{gpsSharing ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="center">{isCheckOut ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="center">{isPaymentLeft ? 'Yes' : 'No'}</TableCell>
                        <TableCell align="center">
                          <Stack sx={{ cursor: 'pointer' }}>
                            <IconButton
                              size="large"
                              title="Copy Link"
                              onClick={() => navigator.clipboard.writeText(`${appConfig.SITE_URL}?bookingId=${_id}`)}
                            >
                              <FaRegCopy size={20} color="#009245" sx={{ cursor: 'pointer' }} />
                            </IconButton>
                          </Stack>
                        </TableCell>
                        <TableCell align="center">{`${appConfig.SITE_URL}?bookingId=${_id}`}</TableCell>
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7} />
                  </TableRow>
                )}
                {loading && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={7}>
                      <CircularProgress size="20px" />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>

              {isNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={7} sx={{ py: 3 }}>
                      <Paper
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Typography variant="h6" paragraph>
                          Not found
                        </Typography>

                        <Typography variant="body2">
                          No results found for &nbsp;
                          <br /> Try checking for typos or using complete words.
                        </Typography>
                      </Paper>
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[100, 200, 300]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>

      <BookingFilterDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        filters={pendingFilters}
        onInputChange={handleInputChange}
        onDateChange={handleDateChange}
        onClearFilters={handleClearFilters}
        onApplyFilters={handleApplyFilters}
      />
    </>
  );
}
